var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
    This file is generated with the "identicons" script.
    To update this output make changes to `scripts/svgr/identicon-icon-template.js
    */
import * as React from 'react';
import { IdenticonsCustomProperty, useColorMap, identiconComponentName } from '../common';
import { styled } from '../../styled';
export var IdenticonLogoutToken = styled(function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    var colorMap = useColorMap({
        color: color,
    });
    var fills = {
        light: "var(".concat(IdenticonsCustomProperty.light, ", ").concat(colorMap.light, ")"),
        base: "var(".concat(IdenticonsCustomProperty.base, ", ").concat(colorMap.base, ")"),
        dark: "var(".concat(IdenticonsCustomProperty.dark, ", ").concat(colorMap.dark, ")"),
    };
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M20.425 5.301L6.478 15.827c-2.109 1.591-2.99 4.4-2.182 6.96l5.325 16.9C10.43 42.262 12.756 44 15.38 44H32.62c2.624 0 4.95-1.742 5.76-4.312l5.324-16.9c.807-2.561-.073-5.37-2.182-6.96L27.585 5.3a5.911 5.911 0 00-7.16 0z", fill: fills.light }),
        React.createElement("path", { d: "M29.95 24.74v-1.847c0-.855 1.035-1.285 1.64-.68l3.082 3.082a.961.961 0 010 1.36l-3.081 3.08c-.606.606-1.641.177-1.641-.679v-1.624l-4.046-.086a1.346 1.346 0 010-2.692l4.046.085z", fill: fills.dark }),
        React.createElement("path", { d: "M12.125 19.406L18.8 14.4c1.319-.989 3.2-.048 3.2 1.6v19a2 2 0 01-2 2h-4.438a2 2 0 01-1.94-1.515l-2.978-11.908a4 4 0 011.48-4.17z", fill: fills.base })));
}, {
    name: identiconComponentName,
})({});
